<div class="months-tiles" data-testid="month-tiles">
    @for (tile of tiles; track tile.date; let i = $index) {
        <div #tileRef class="month-tile" data-testid="month-tile">
            <div class="month-tile-title">
                @if (!tile.isToday) {
                    <button
                        mat-button
                        class="month-tile-button"
                        data-testid="month-tile-name"
                        (click)="monthClick(tile.date)">
                        {{ tile.text }}
                    </button>
                }
                @if (tile.isToday) {
                    <button
                        mat-raised-button
                        class="month-tile-button"
                        data-testid="month-tile-name-today"
                        color="primary"
                        (click)="monthClick(tile.date)">
                        {{ tile.text }}
                    </button>
                }
            </div>
            @if (isLoading) {
                <div class="month-tile-loading" data-testid="month-tile-loading">
                    <div>
                        <ngx-skeleton-loader
                            [theme]="{ width: '12px', height: '12px', margin: 0 }"></ngx-skeleton-loader>
                    </div>
                    <div>
                        <ngx-skeleton-loader
                            [theme]="{ width: '30px', height: '12px', margin: 0 }"></ngx-skeleton-loader>
                    </div>
                    <div class="desc">
                        <ngx-skeleton-loader [theme]="{ height: '12px', margin: 0 }"></ngx-skeleton-loader>
                    </div>
                </div>
            }
            @if (!isLoading) {
                @for (doc of showTileDocs(tile.docs); track doc) {
                    <app-calendar-doc-mini
                        [doc]="doc"
                        [screenFields]="displayScreenFields()"
                        [actions]="actions()"></app-calendar-doc-mini>
                }
                @if (getMoreTileDocsNumber(tile.docs); as n) {
                    <div class="month-tile-more" data-testid="month-tile-doc-more">
                        <button
                            mat-button
                            class="more month-tile-button"
                            data-testid="month-tile-doc-more-button"
                            #btMore
                            (click)="more(tile, btMore)">
                            {{ "MODULE_INSTANCE_CALENDAR.N_MORE" | translate: { n: n } }}
                        </button>
                    </div>
                }
            }
        </div>
    }
</div>
